import { round } from "lodash";
import { LocalStorageProduct } from "ts/api/product";

// A linked-property quantity is a float (stand area, wall length); adding or
// taking 1 from it drifts (32.44 - 1 = 31.439999999999998).
const roundCartQuantity = (quantity: number) => round(quantity, 2);

const roundIfNumber = (quantity: number) =>
  typeof quantity === "number" ? roundCartQuantity(quantity) : quantity;

/**
 * A stored cart line with its quantities rounded, for lines saved before the
 * writes were rounded. Returns the same object when nothing drifted.
 */
export const roundStoredCartQuantities = (
  item: LocalStorageProduct
): LocalStorageProduct => {
  const extras = item.extras?.map((extra) => ({
    ...extra,
    quantity: roundIfNumber(extra.quantity),
  }));
  const cartQuantity = roundIfNumber(item.cartQuantity);
  const isDrifted =
    cartQuantity !== item.cartQuantity ||
    !!extras?.some(({ quantity }, index) => {
      return quantity !== item.extras?.[index]?.quantity;
    });

  return isDrifted ? { ...item, cartQuantity, extras } : item;
};

export default roundCartQuantity;
